<template>
  <div class="search-input">
    <div class="search-input__label">{{ label }}</div>
    <v-autocomplete
      append-icon=""
      attach
      background-color="white"
      class="search-input__body"
      height="40px"
      hide-details="auto"
      outlined
      placeholder="Найти..."
      v-bind="$attrs"
      v-bind:items="items"
      v-bind:value="value"
      v-on:input="onInputItem"
    >
      <template v-slot:append>
        <div class="search-input__icon-search" />
      </template>
      <template v-slot:item="{ item }">
        <slot
          name="item"
          v-bind:item="item"
        >{{ item[$attrs['item-text'] || 'text'] }}</slot>
      </template>
      <template v-slot:append-outer>
        <button
          v-bind:disabled="!hasOpenModal"
          class="search-input__icon-file"
          type="button"
          v-on:click="onOpenModal" />
      </template>
      <template v-slot:no-data>
        <p style="padding: 10px; margin:0;">Результатов нет</p>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  methods: {
    /**
     * @description Обработать выбор элемента.
     * @param {any} updatedValue Обновленное значение.
     * @returns {void}
     */
    onInputItem(updatedValue) {
      this.$emit('input', updatedValue);
    },
    /**
     * @description Обработать событие открытия модального окна.
     * @returns {void}
     */
    onOpenModal() {
      this.$emit('open-modal');
    },
  },
  props: {
    /**
     * @description Элементы поиска.
     * @type {any[]}
     */
    items: {
      required: true,
      type: Array,
    },
    /**
     * @description Заголовок.
     * @type {string}
     */
    label: { type: String, required: true },
    /**
     * @description Выбранное значение.
     * @type {any}
     */
    value: { required: true },
    /**
     * @description Может открывать модальное окно.
     * @type { boolean }
     */
    hasOpenModal: { default: () => false, type: Boolean },
  },
};
</script>

<style lang="scss">
.search-input {
  display: flex;
  flex-direction: column;
  gap: 3px;
  &__label {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #90a0b7;
  }
  &__body {
    position: relative;
    max-width: 100%;
    color: var(--border-color) !important;
    &.primary--text {
      color: var(--action-color) !important;
      .search-input__icon-file {
        border: 1px solid var(--action-color);
        border-left: none;
      }
    }
    &:not(.v-input--is-focused):not(.v-input--has-state) {
      .v-input__control {
        fieldset {
          color: var(--border-color) !important;
        }
        .v-input__slot:hover fieldset {
          color: rgba(0, 0, 0, .86) !important;
        }
      }
    }
    & .v-input__slot {
      min-height: 40px !important;
      & > .v-select__slot {
        & > input {
          padding-left: 25px;
          padding-right: 5px;
          text-overflow: ellipsis;
        }
        & > .v-input__append-inner {
          margin-top: 7px !important;
          margin-left: 25px !important;
        }
      }
    }
    & > .v-input__append-outer {
      margin-left: 0 !important;
    }
    &
      .v-menu__content
      > .v-sheet
      > .v-list-item
      > .v-list-item__content
      > .v-list-item__title {
      white-space: pre-line !important;
    }
  }
  &__icon-search {
    position: absolute;
    left: 2px;
    top: 12px;
    background-repeat: no-repeat;
    background-image: url("@/assets/img/search-black.svg");
    background-size: contain;
    width: 15px;
    height: 15px;
  }
  &__icon-file {
    position: absolute;
    right: 1px !important;
    top: 1px !important;
    background-repeat: no-repeat;
    background-image: url("@/assets/img/file.svg");
    background-position: center;
    background-color: #eaeff3;
    border-radius: 0 3px 3px 0;
    width: 38px;
    height: 38px;
  }
}
</style>
